import {widgetFromDomaintypeGenerator} from "../../misc/widget-functions"
import React, {useMemo} from "react"
import {Grid} from "@mui/material"
import Content from "../../components/Content"

export const objektToWidgetsPrototype = [
    {key: "basePointer", type: "STRING", label: "Basepointer", size: 3},
]

const ObjektToWidgets = ({widget, value}) => {
    const merkmalList = value?.connections?.map(entry => entry.origin)
    const widgetList = useMemo(
        () =>
            Array.isArray(merkmalList)
                ? merkmalList?.map((merkmal) =>
                    widgetFromDomaintypeGenerator(
                        merkmal,
                        `${widget.basePointer}${merkmal.pointer}`
                    ),
                )
                : [],
        [],
    )

    return (
        <Grid container display="flex" flexDirection="column" spacing={1}>
            {widgetList.map((entry) => (
                <Grid key={entry.id} item size={12}>
                    <Content
                        child={entry}/>
                </Grid>
            ))}
        </Grid>
    )
}

export default ObjektToWidgets
